<template>
  <div>
    <div class="header-bg container-fluid ">
      <div id="scroll-style" class="scroll-tab">
        <div class="inline mb-1 row">

          <div class="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-5 mb-2">
            <!--                    <div class="col-xl-1 col-lg-1 col-md-3 col-sm-3 col-4 status-tab mr-xl-3 mr-lg-5">-->
            <b-button class="header-text home-button mr-md-3" router-link to="/status" variant="light">
              <i class="fas fa-home mt-2"></i>
              <br>

            </b-button>

            <template v-if="$route.path ==  '/event-form' ">
              <b-button :disabled="form.id == ''" class="header-text home-button " variant="light"
                        @click="printEventPDF(form.id)">
                <i class="fas fa-print mt-2"></i>
                <br>
              </b-button>
            </template>
          </div>

          <b-button class="ml-lg-5 col-xl-4 col-lg-5 col-md-7 col-sm-7 col-7 header-text status-tab" router-link
                    to="/event-form"
                    variant="light">
            <template v-if="form.id">
              <!--                            <span class="col-form-label">วันที่ {{form.report_date }}  สถานะ : ไม่บาดเจ็บ {{form.no_injury_patient}} บาดเจ็บ {{form.injury_patient}}  ตาย {{form.death_patient}}</span>-->
              <span class="col-form-label">วันที่ {{ form.report_date |  moment('add','543 year','D/MM/YYYY') }}  สถานะ : ไม่บาดเจ็บ {{
                  form.no_injury_patient
                }} บาดเจ็บ {{ form.injury_patient }}  ตาย {{ form.death_patient }}</span>
            </template>
            <template v-else>
              <!--                            <span class="col-form-label">วันที่ {{currentDate}} สถานะ : ไม่บาดเจ็บ 0 บาดเจ็บ 0  ตาย 0</span>-->
              <span class="col-form-label">วันที่ {{ currentDate | moment('add','543 year','D/MM/YYYY') }} สถานะ : ไม่บาดเจ็บ 0 บาดเจ็บ 0  ตาย 0</span>
            </template>

          </b-button>

          <div class="col-xl-4 col-md-1 col-1 inline">
            <template v-for="index in form.total_patient">
              <b-button :disabled="!form.id"
                        class="header-text person-button " variant="light"
                        @click="goToDrowningForm(form.id,index)">
                <br><span>รายที่</span>
                <br><br><span>{{ index }}</span>
              </b-button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 140px;">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { domain } from '../../util/Constants'

export default {
  name: 'DrowningHeader',
  created () {
    this.checkLogin()
    this.getCurrentDate()
    // console.log(this.form.report_date);
  },
  computed: {
    ...mapState({
      user_login: state => {
        return state.Auth.user_login
      },
      form: state => {
        return state.Event.form
      },
      form_patient: state => {
        return state.Patient.form
      },
    })
  },
  data () {
    return {
      currentDate: '',
    }
  },
  methods: {
    getCurrentDate () {
      this.currentDate = moment().format('YYYY-MM-DD')
    },
    checkLogin () {
      if (this.user_login == null) {
        this.$router.push({
          name: 'LoginView'
        })
      }
    },
   async goToDrowningForm (event_id, order = '') {
      // alert("start")
      // alert(order)
      // alert(event_id)
   await this.$store.dispatch('Patient/showPatient', {
        event_id: event_id,
        order: order
      }).then(() => {
        console.log('path', this.$router)
        if (this.form_patient.id) {
          // alert("if")
          this.$router.push({
            name: 'DrowningForm',
            params: { order }
          })
        } else {
          // alert("else")
          this.$router.push({
            name: 'DrowningForm',
            params: { order }
          })
          this.$store.dispatch('Patient/clearFormData')
          this.$store.dispatch('Patient/setOrder', order)
        }
      })
    },

    printEventPDF (id) {
      const token = this.$store.state.Auth.accessToken
      window.open(domain + '/event_pdf/' + id + (token ? '?token=' + encodeURIComponent(token) : ''), '_blank')
    },
    printPatientPDF (id) {
      const token = this.$store.state.Auth.accessToken
      window.open(domain + '/event_pdf/' + id + (token ? '?token=' + encodeURIComponent(token) : ''), '_blank')
    },
  }
}
</script>

<style scoped>

.row {
  margin: 0;
}

.header-text {
  color: #006738;
  background-color: white;
  border-radius: 5px;
  text-align: center;
  display: inline;
  font-weight: 700;
  overflow: hidden;
}

.status-tab {
  height: 52px;
  padding: 4px 10px;
  font-size: 24px;
}

.status-tab span {
  display: inline-block;
  vertical-align: center;
}

.person-button {
  line-height: 10px;
  font-size: 20px;
  width: 50px;
  display: inline-block;
  margin: 0 5px;
  border: 0;
  white-space: nowrap;
}

.home-button {
  line-height: 25px;
  font-size: 20px;
  width: 50px;
  display: inline-block;
  margin: 0 5px;
  border: 0;
  white-space: nowrap;
}

.scroll-tab {
  width: 100%;
  overflow-x: auto;
  display: inline-block;
  white-space: nowrap;
  margin-bottom: 10px;
  margin-top: 10px;
  border-radius: 5px;
}

.header-bg {
  background-color: #006738;
  height: fit-content;
  padding-top: 10px;
  padding-left: 18px;
  padding-right: 15px;
  position: fixed;
  top: 0;
  z-index: 10;
}

#scroll-style::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: whitesmoke;
}

#scroll-style::-webkit-scrollbar {
  width: 5px;
  background-color: whitesmoke;
}

#scroll-style::-webkit-scrollbar-thumb {
  background-color: #006738;
  border: 2px solid white;
}

@media only screen and (max-width: 767px) {
  .status-tab {
    height: fit-content;
    font-weight: 700;
    font-size: 21px;
  }

  .person-button {
    font-size: 15px;
  }
}

@media only screen and (max-width: 567px) {
  .status-tab {
    height: fit-content;
    font-weight: 700;
    font-size: 19px;
  }

  .person-button {
    font-size: 15px;
  }
}

@media only screen and (max-width: 500px) {
  .status-tab {
    height: fit-content;
    font-weight: 700;
    font-size: 18px;
  }

  .person-button {
    font-size: 15px;
  }
}


</style>
